import styled from '@mui/material/styles/styled';

import { M3ButtonBase } from './M3Button.styles';

export const M3ButtonTonedBase = styled(M3ButtonBase)`
  border: 2px solid transparent;
  box-shadow: inset 0 0 0 2px transparent;
  color: var(--md-ref-palette-secondary10);
  background-color: var(--md-ref-palette-secondary90);

  &:hover {
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.04), rgba(0, 0, 0, 0.04)),
      var(--md-ref-palette-secondary90);
  }

  &.dark-mode-button {
    &.MuiButton-text {
      color: var(--md-ref-palette-secondary90);
      background-color: var(--md-ref-palette-secondary20);
    }

    &:hover {
      &.MuiButton-text .MuiSvgIcon-root,
      &.MuiButton-text {
        color: var(--md-ref-palette-secondary90);
      }

      background: linear-gradient(
          0deg,
          rgba(255, 255, 255, 0.04),
          rgba(255, 255, 255, 0.04)
        ),
        var(--md-ref-palette-secondary10);
    }
  }
`;
